// src/pages/VerifyEmail.js
import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const verifyToken = async () => {
      try {
        await axios.patch(
          "https://your-directus-instance.com/users/me/track/page",
          {
            token: params.get("token"),
          }
        );

        await axios.post(
          "https://your-directus-instance.com/users/me/accept-invite",
          {
            token: params.get("token"),
            password: "user_password", // If needed
          }
        );

        setStatus("verified");
      } catch (error) {
        setStatus("failed");
      }
    };

    verifyToken();
  }, [params]);

  return (
    <div>
      {status === "verifying" && <p>Verifying...</p>}
      {status === "verified" && <p>Email verified successfully!</p>}
      {status === "failed" && <p>Verification failed or link expired</p>}
    </div>
  );
};

export default VerifyEmail;
